import React, { Component } from "react";
import { Chart } from "chart.js";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button,
} from "@mui/material";
const buildData = (slaveTempArr,slaveNoArr)=>{
 
  const _data = {
    datasets: [
      {
        backgroundColor: "#0892A5",
        barPercentage: 0.5,
        barThickness: 12,
        borderRadius: 4,
        categoryPercentage: 0.5,
        data: slaveTempArr,
        label: "Slave Temperature",
        maxBarThickness: 10,
      },
    ],
    labels: slaveNoArr ,
  };
  return _data 
}
  
  const _options = {
    animation: false,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    xAxes: [
      {
        ticks: {
          fontColor: "textSecondary",
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          fontColor: "textSecondary",
          beginAtZero: true,
          min: 0,
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
        },
      },
    ],
    tooltips: {
      backgroundColor: "#C1ECE2",
      bodyFontColor: "textSecondary",
      borderWidth: 1,
      enabled: true,
      footerFontColor: "textSecondary",
      intersect: false,
      mode: "index",
      titleFontColor: "textPrimary",
    },
  };

class SlaveTempChartWrap extends Component {

  constructor(props) {
    super(props);

  }

  componentDidMount() {
    const {slaveTempArr, slaveNoArr} = this.props;
    console.log('Data',slaveTempArr,"Options",slaveNoArr);
    this.chart = new Chart(this.refs.chart, {
      type: "line",
      data: buildData(slaveTempArr, slaveNoArr),
      options: _options,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {slaveTempArr, slaveNoArr} = this.props;

    this.chart.data.datasets[0].data = slaveTempArr;
    this.chart.data.labels = slaveNoArr;
    this.chart.update();
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  render() {
    
    return (
      <Card>
        <CardHeader
          title="Slave Temperature"
        />
        <Divider />
        <CardContent>
          <Box
            sx={{
              height: 400,
              position: "relative",
            }}
          >
            <canvas ref="chart"></canvas>
          </Box>
        </CardContent>
      </Card>
    );
  }
}
export default SlaveTempChartWrap;
